import { render, staticRenderFns } from "./StatusFilter.vue?vue&type=template&id=aa2fafa6&scoped=true"
import script from "./StatusFilter.vue?vue&type=script&lang=ts"
export * from "./StatusFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2fafa6",
  null
  
)

export default component.exports